import React from "react";
const VARIANTS = {
    neutral: "bg-surface-sunken text-fg-muted",
    brand: "bg-brand-100 text-brand-800",
    success: "bg-success-soft text-success",
    warning: "bg-warning-soft text-warning",
    danger: "bg-danger-soft text-danger",
    outline: "border border-border-strong text-fg-muted",
    /** Alias suave (admin / métricas secundarias) */
    muted: "bg-surface-sunken text-fg-subtle",
};
const SIZES = {
    sm: "px-1.5 py-0.5 text-[10px]",
    md: "px-2 py-0.5 text-xs",
};
export default function Badge({ variant = "neutral", size = "md", className = "", children, icon: Icon, }: {
    variant?: keyof typeof VARIANTS;
    size?: keyof typeof SIZES;
    className?: string;
    children?: React.ReactNode;
    icon?: React.ComponentType<{
        className?: string;
    }>;
}): any {
    const v = VARIANTS[variant] ?? VARIANTS.neutral;
    const s = SIZES[size] ?? SIZES.md;
    return (<span className={`inline-flex items-center gap-1 rounded-full font-medium uppercase tracking-wide ${v} ${s} ${className}`}>
      {Icon && <Icon className="w-3 h-3"/>}
      {children}
    </span>);
}
